import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-brand-carbon selection:bg-brand-yellow" data-id="element-0" data-mp="33oriy2lrxzq1">
      <noscript data-id="element-1" data-mp="38num1hi71vvd">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dkus3sf1mymh" />
      </noscript>

      <Hero data-id="element-3" data-mp="su427axbqqc2" />
      <main data-id="element-4" data-mp="stko65asom3b">
        <ProblemSection data-id="element-5" data-mp="stccggqermtp" />
        <SolutionSection data-id="element-6" data-mp="swqbpg3rzfwx" />
        <BonusesSection data-id="element-7" data-mp="3686tkdjumw2" />
        <BenefitsSection data-id="element-8" data-mp="35gkl05ue1ig" />
        <OfferSection data-id="element-9" data-mp="34x4lozr5n72" />
        <GuaranteeSection data-id="element-10" data-mp="38b6yx8f1wei" />
        <Testimonials data-id="element-11" data-mp="3udaw269tuj3n" />
        <FAQSection data-id="element-12" data-mp="3ubriinfk2m5k" />
        <FinalCTA data-id="element-13" data-mp="3ucjbrrlok7so" />
      </main>
      <Footer data-id="element-14" data-mp="d4nvzht0nm2x" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="d3mkjc838xko" />}
    </div>;
}